/**
 * @return {{ page: string, page_type: string}}
 */
export const searchV2 = () => ({
  page: 'recherche',
  page_type: 'recherche',
});
